<h2 mat-dialog-title>Edit list option value</h2>

<mat-dialog-content *ngIf="!loading">
    <div class="add-lookup-form" [formGroup]="form">
        <app-localization-text-form-field
            [formElement]="{ formControl: 'text', localizationValueParam: 'text', text: ('ListOptionValue' | translate: {Default: 'List Option Value'}), disabled: 'false' }"
            [parentGroup]="form"
            [cultures]="cultures"
            [showTitle]="false"
            (emitAddtoFormArray)="addNewLocalization()"
            (emitDeleteFromFormArray)="deleteLocalization($event.index)"
        ></app-localization-text-form-field>

        <mat-form-field  appearance="fill">
            <mat-label>
                Start Date
            </mat-label>
        
            <input matInput [matDatepicker]="startDatePicker" formControlName="startDate">
            <span fxLayout="row" matSuffix>
                <mat-datepicker-toggle  [for]="startDatePicker"></mat-datepicker-toggle>
            </span>
            <mat-datepicker #startDatePicker></mat-datepicker> 
        </mat-form-field>

        <mat-form-field  appearance="fill">
            <mat-label>
                End Date
            </mat-label>
        
            <input matInput [matDatepicker]="endDatePicker" formControlName="endDate">
            <span fxLayout="row" matSuffix>
                <mat-datepicker-toggle  [for]="endDatePicker"></mat-datepicker-toggle>
            </span>
            <mat-datepicker #endDatePicker></mat-datepicker> 
        </mat-form-field>

        <mat-slide-toggle setColor="primaryColour" formControlName="prioritize">Prioritize</mat-slide-toggle>

        <div class="buttons-container">
            
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions *ngIf="!loading">
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">Close</button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!form.valid">Save</button>
</mat-dialog-actions>